import { type TestId } from '@repo/test-id';
import { useGeoPosition } from '@repo/geo-position';

import { useLocationPermission } from '@features/parkingMap/hooks/useLocationPermission';
import LocationPermissionModal from '@features/parkingMap/components/locationPermission/LocationPermissionModal';

import Dialog from '@shared/components/Dialog';

interface Props {
  testId: TestId;
}

export default function LocationPermissionDialog({ testId }: Props) {
  const { isKnown, isPermissionGranted } = useGeoPosition();
  const { visible, dismiss } = useLocationPermission();

  return (
    <Dialog opened={!isPermissionGranted && !isKnown && visible} stickerTop="-top-15" testId={testId.append('drawer')}>
      <LocationPermissionModal testId={testId} onLater={dismiss} className="py-6" />
    </Dialog>
  );
}
